// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"a5224ad1","794":"d210cd15","984":"70fa4017"}[chunkId] + ".chunk.js";
};